"use client";

import IconArrow from "@/components/UI/Icon/IconArrow/IconArrow";
import useRegionAndLocale from "@/hooks/useRegionAndLocale";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import clsx from "clsx";
import { usePathname } from "next/navigation";
import React, { HTMLAttributeAnchorTarget } from "react";
import styles from "./SelectNavigation.module.scss";

interface SelectNavigationProps {
	title: string;
	links: {
		text: string;
		href: string;
		target?: HTMLAttributeAnchorTarget;
	}[];
	className?: string;
}

const SelectNavigation: React.FC<SelectNavigationProps> = ({
	title,
	links,
	className,
}) => {
	const { region, lang } = useRegionAndLocale();
	const path = usePathname();

	const activeLink = links.find((link) => {
		if (link.href.startsWith("/")) {
			link?.href === path;
		}

		const pathStripped = path?.replace(`/${region}/${lang}/`, "");

		return link.href === pathStripped;
	});

	return (
		<NavigationMenu.Root className={clsx([styles.root, className])}>
			<NavigationMenu.List className={styles.list}>
				<NavigationMenu.Item>
					<NavigationMenu.Trigger className={styles.trigger}>
						<div>
							<span>{title}</span>
							{activeLink?.text}
						</div>
						<IconArrow
							direction={"down"}
							aria-labelledby='directional chevron pointing down'
						/>
					</NavigationMenu.Trigger>
					<NavigationMenu.Content className={styles.content}>
						{links.map((link, index) => {
							return (
								<NavigationMenu.Link
									key={index}
									href={link?.href}
									target={link?.target}
									className={`${styles.link} ${
										activeLink?.href === link.href ? styles.active : ""
									}`}
									active={activeLink?.href === link.href}
								>
									{link.text}
								</NavigationMenu.Link>
							);
						})}
					</NavigationMenu.Content>
				</NavigationMenu.Item>
			</NavigationMenu.List>
		</NavigationMenu.Root>
	);
};

export default SelectNavigation;
